export { default as Resources } from "./main";

import * as Anchors from "./anchors";
import { default as routes } from "./routes";

export const resources$ = {
  Anchors,
  routes,
};
